import * as React from 'react';
import { createSvg } from './utils/createSvg';
export var FlagIn = createSvg(React.createElement(React.Fragment, null,
    React.createElement("path", { fill: "#f93", d: "M0 0h512v170.667H0z" }),
    React.createElement("path", { fill: "#fff", d: "M0 170.667h512v170.667H0z" }),
    React.createElement("path", { fill: "#128807", d: "M0 341.333h512V512H0z" }),
    React.createElement("g", { transform: "translate(256 256) scale(3.41333)" },
        React.createElement("circle", { r: "20", fill: "#008" }),
        React.createElement("circle", { r: "17.5", fill: "#fff" }),
        React.createElement("circle", { r: "3.5", fill: "#008" }),
        React.createElement("g", { id: "FlagIn-d" },
            React.createElement("g", { id: "FlagIn-c" },
                React.createElement("g", { id: "FlagIn-b" },
                    React.createElement("g", { id: "FlagIn-a", fill: "#008" },
                        React.createElement("circle", { r: ".875", transform: "rotate(7.5 -8.75 133.5)" }),
                        React.createElement("path", { d: "M0 17.5L.6 7 0 2l-.6 5L0 17.5z" })),
                    React.createElement("use", { height: "100%", width: "100%", xlinkHref: "#FlagIn-a", transform: "rotate(15)" })),
                React.createElement("use", { height: "100%", width: "100%", xlinkHref: "#FlagIn-b", transform: "rotate(30)" })),
            React.createElement("use", { height: "100%", width: "100%", xlinkHref: "#FlagIn-c", transform: "rotate(60)" })),
        React.createElement("use", { height: "100%", width: "100%", xlinkHref: "#FlagIn-d", transform: "rotate(120)" }),
        React.createElement("use", { height: "100%", width: "100%", xlinkHref: "#FlagIn-d", transform: "rotate(-120)" }))), '0 0 512 512', 'FlagIn');
//# sourceMappingURL=FlagIn.js.map